<template>
    <div>
        <div class="header-wrapper">
        </div>

        <div class="dashboard-content">
            <b-container>
                <b-row class="justify-content-md-center">
                    <b-col lg="10" md="12" sm="12" class="notice-box">
                        <div class="heading">Announcement</div>
                        <div class="content">
                            <ul>
                                <li class="notice-list" v-for="(item, index) in anouncements" :key=index>
                                    <strong>{{item.title}}</strong> - <span>{{item.message}}</span>
                                </li>
                            </ul>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="justify-content-md-center">
                    <b-col lg="10" md="12" sm="12" class="p-0">
                        <!-- <div class="l-button success">Request online access</div>
                        <div class="l-button primary">Just arrived</div> -->
                    </b-col>
                </b-row>

                <b-row class="mt-3 justify-content-md-center">
                    <b-col lg="10" md="12" sm="12" class="c-box p-0">
                       <div class="live-session mt-4">
                            <div class="content-card">
                                <div class="status">Upcoming</div>
                                <div class="title">Leaders Camp 2020</div>
                                <div class="author">17th November 2020</div>
                                <!-- <div class="btns">
                                    <div class="live-button"><span class="fe-play"></span>  Watch live</div>
                                    <div class="live-button music"><span class="fe-music"></span>  Listen live</div>
                                </div> -->
                            </div>
                           <div class="card-image show-mmd">
                               <div class="image-box">
                                   <img src="@/assets/bg-2.jpg" alt="">
                               </div>
                           </div>
                       </div>
                    </b-col>

                    <!-- <b-col lg="10" md="12" sm="12" class="c-box p-0">
                       <div class="live-session mt-4">
                            <div class="content-card">
                                <div class="status">Live session</div>
                                <div class="title">How to Teach The Word With Power And Authority</div>
                                <div class="author">by Pastor Elikem</div>
                                <div class="btns">
                                    <div class="live-button"><span class="fe-play"></span>  Watch live</div>
                                    <div class="live-button music"><span class="fe-music"></span>  Listen live</div>
                                </div>
                            </div>
                           <div class="card-image show-mmd">
                               <div class="image-box">
                                   <img src="@/assets/bg.jpg" alt="">
                               </div>
                           </div>
                       </div>
                    </b-col> -->

                    <!-- <b-col lg="10" md="12" sm="12" class="c-box p-0 mt-20">
                       <div class="live-session mt-4">
                            <div class="content-card">
                                <div class="status">Up next</div>
                                <div class="title">How to Teach The Word With Power And Authority</div>
                                <div class="author">by Pastor Elikem</div>
                                <div class="time">starts 12:30 PM</div>
                            </div>
                           <div class="card-image show-mmd">
                               <div class="image-box">
                                   <img src="@/assets/bg-1.jpg" alt="">
                               </div>
                           </div>
                       </div>
                    </b-col> -->

                    <b-col lg="10" md="12" sm="12" class="c-box p-0 mt-20" v-if="user.isHosted">
                       <div class="live-session room mt-4">
                            <div class="content-card">
                                <div class="status blue">Room allocation</div>
                                <div class="title mb-3">{{room.host.fullname}} - {{room.area}} {{room.name}}</div>
                                <div class="list-labels">
                                    <span class="fe-map-pin icon"></span>
                                    {{room.address}}<a :href="room.googlemaplink" target="_">view on map here</a>
                                </div>
                                <div class="list-labels">
                                    <span class="fe-users icon"></span>capacity 
                                    {{room.capacity}}
                                </div>
                                <div class="list-labels">
                                    <span class="fe-phone icon"></span>call for assistance 
                                    {{'0265274457'}}
                                </div>
                            </div>
                            <div class="card-image show-mmd">
                               <div class="image-box">
                                   <img src="@/assets/hostel-1.jpg" alt="">
                               </div>
                            </div>
                            <b-row>
                                <b-col md="12">
                                    <div class="horizontal-line"></div>
                                </b-col>
                                <b-col sm="12" md="6"  lg="6" class="mb-3" v-for="(item, i) in room.members" :key="i">
                                    <div class="mate">
                                        <div class="name">{{item.role[0] +' '+item.firstname+' '+item.lastname}}</div>
                                        <div class="contact">{{item.phone}}</div>
                                        <div class="contact">{{item.church}}</div>
                                    </div>
                                </b-col>
                            </b-row>
                       </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import vueCustomScrollbar from 'vue-custom-scrollbar';

    export default {
        components: {
            vueCustomScrollbar
        },
        data(){
            return {
                anouncements: [],
                schedule: [],
                room: {}
            }
        },
        computed: {
            ...mapGetters({user: 'USER'})
        },
        methods: {
            getAnouncements(){
                this.$http.get('get-announcement')
                .then(res => {
                    this.anouncements = res.body.anouncement
                })
                .catch(err => {
                    console.log(err)
                })
            },
            getSchedule(){
                this.$http.get('get-current-schedule')
                .then(res => {
                    this.schedule = res.body.schedule
                    console.log(this.schedule)
                })
                .catch(err => {
                    console.log(err)
                })
            },
            getAssignedRoom(){
                this.$http.get('get-room/'+this.user.userRoom)
                .then(res => {
                    this.room = res.body.room
                   
                })
                .catch(err => {
                    console.log(err)
                }) 
            }
        },
        created(){
            this.getAnouncements()
            this.getSchedule()
            this.getAssignedRoom()
        }  
    }
</script>

<style lang="scss" scoped>
   
    .header-wrapper{
        padding: 20px;
        text-align: center;
        font-size: 20px;
        margin-top: 0px !important;
        color: #182c8f; 
        font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif ;
        h1{
            margin-bottom: 0;        
        }
    }
    .notice-box{
        min-height: 120px;
        background-color: #182c8f;
        border-radius: 10px;
        padding: 20px;
        color: white;
        margin-bottom: 20px;
        .heading{
            font-weight: bold;
            font-size: 18px;
            font-family: Arial, Helvetica, sans-serif
        }
        .content{
            margin-top: 20px;
            font-family: Arial, Helvetica, sans-serif;
            margin-left: 10px;
        }
        ul{
            padding: 0;
        }
        .notice-list{
            list-style: none;
            padding: 5px 0px;
        }
    }
    table{
        width: 100%;
        td{
            padding: 0;
        }
    }
    .schedule-item{
        &.live{
            td{
                background-color: rgba(56, 230, 123, 0.815);
                .time{
                        color: white;
                }
                .message{
                    .title{
                        color: white;
                    }
                    .subtitle{
                        color: white;
                    }
                }
                .play-btn{
                    background-color: white;
                    color:  rgba(56, 230, 123, 0.815);
                }
            }
        }
        td{
            border-bottom: 1px solid rgba(192, 192, 192, 0.212);
            .time{
                padding: 10px;
                vertical-align: middle;
                color: rgb(35, 35, 83);
                font-weight: bold;
                font-size: 16px;
                line-height: 45px;
            }
            .message{
                padding: 10px;
                .title{
                    color: rgb(35, 35, 83);
                    font-weight: bold;
                }
                .subtitle{
                    color: silver;
                    font-size: 16px;
                }
            }
            .play-btn{
                background-color: red;
                width: 130px;
                padding: 5px 10px;
                color: white;
                border-radius: 25px;
                cursor: pointer;
                text-align: center;
                margin: 17px auto 0 auto;
            }
            
        }
    }

    .live-session{
        background-color: #e8ecff;
        min-height: 100px;
        width: 100%;
        border-radius: 10px;
        padding: 15px;
        padding-bottom: 40px;
        overflow: hidden;

        .card-image{
            width: 350px;
            height: 300px;
            background-color: slategray;
            float: right;
            border-radius: 10px;
            border-bottom-right-radius: 30%;
            position: relative;
            transform-style: preserve-3d;
            .image-box{
                width: 100%;
                height: 100%;
                border-radius: 10px;
                border-bottom-right-radius: 30%;
                overflow: hidden;
                img{
                    width: 130%;
                }
            }
            // overflow: hidden;
            &::after{
                content: "";
                position: absolute;
                border-radius: 10px;
                border-bottom-right-radius: 30%;
                width: 100%;
                height: 100%;
                border: 2px solid orangered; 
                left: -13px;
                top: 20px;
                transform: translateZ(-1px);
            }
        }

        .horizontal-line{
            width: 70%;
            height: 2px;
            background-color: silver;
            margin: 20px auto;
        }

        .content-card{
            width: calc(100% - 380px);
            display: inline-block;
            .status{
                color: rgb(26, 192, 26);
                font-size: 20px;
                position: relative;
                margin-left: 60px;
                &.blue{
                    color:#182c8f;
                    &::before{
                        background-color: #182c8f;
                    }
                }
                &:before{
                    content: "";
                    left: -55px;
                    top: 15px;
                    position: absolute;
                    width: 50px;
                    height: 2px;
                    background-color: rgb(26, 192, 26);
                }
            }
            .title{
                font-size: 35px;
                margin-top: 10px;
                font-weight: bold;
                color: #121e5a;
            }

            .author{
                font-size: 20px;
                color: slategrey;
                margin-top: 10px;
            }

            .time{
                background-color: #182c8f;
                padding: 7px 15px;
                margin-top: 10px;
                color: white;
                border-radius: 5px;
                width: 150px;
            }

            .live-button{
                background-color: red;
                padding: 7px 15px;
                color: white;
                margin-top: 20px;
                width: 150px;
                text-align: center;
                border-radius: 25px;
                display: inline-block;
                margin-right: 20px;
                cursor: pointer;
                &.music{
                    background-color: orange;
                }
                &.success{
                    background-color: green;
                }
            }

            .list-labels{
                margin-top: 10px;
                .icon{
                    text-align: center;
                    line-height: 30px;
                    border-radius: 50%;
                    color: #121e5a;
                    display: inline-block;
                    font-size: 18px;
                    margin-right: 5px;
                }
            }
        }
    }

    .mate{
        .name{
            color:#121e5a;
            font-weight: bold;
        }
    }

    @media screen and (min-width: 750px) and (max-width: 920px){

      .live-session{
        .card-image{
          width: 250px !important;
          height: 200px;
        }
        .content-card{
            width: calc(100% - 280px);
            .title{
                font-size: 2em;
            }
        }
      }
    }

    @media screen and (max-width: 750px){

      .live-session{
        .card-image{
          width: 250px !important;
          height: 200px;
        }
        .content-card{
            width: 100%;
            .title{
                font-size: 2em;
            }
        }
      }
    }
</style>